import { Collapse, Dropdown, Toast } from 'bootstrap';
import { setSearchViewMode } from './SearchViewMode';

import './vue/vue-components';

// import './pages/cart';
// import './pages/detailPage';
// import './pages/listviewPage';


//Save viewMapMode in Localstorage
const setMapViewBtn = document.getElementById("SetMapViewMode");
if (setMapViewBtn != null) {
  setMapViewBtn.addEventListener("click", () => {
    const querystring = window.location.search;
    const urlParams = new URLSearchParams(querystring);
    urlParams.set("ViewMode", "mapView");
    setSearchViewMode("mapView");
    window.location.href = window.location.origin + window.location.pathname + "?" + urlParams.toString();
  })
}

///*Payment  submit form on load*/
//window.onload = function () {
//  const form = document.forms['orderpayment'];
//  if (form != null) {
//    form.submit();
//  }
//}




var userdropdown = document.getElementById('dropdownprofile');
if (userdropdown != null) {
  var options: Partial<Dropdown.Options> = {
    offset: 30
  };

  var modal = new Dropdown(userdropdown, options);
}


var toastElList = [].slice.call(document.querySelectorAll('.toast'))
var toastList = toastElList.map(function (toastEl) {

  let toast = new Toast(toastEl);
  (<any>toast).show();
  return toast;
})


var collapseSearchFilterElementList = [].slice.call(document.querySelectorAll('.navbar-collapse'));

var collapseSearchList = <Collapse[]>collapseSearchFilterElementList.map(function (collapseSearchFilterEl: HTMLElement) {
    return new Collapse(collapseSearchFilterEl, { toggle: false, parent: ".navbar" });
});
collapseSearchList.map((ele) => {
    document.getElementById("main-nav-toggler").addEventListener("click", (e) => {
        ele.toggle();
    });
});


/* When the user scrolls down, hide the navbar. When the user scrolls up, show the navbar */
const scrollUp = "scroll-up";
const scrollDown = "scroll-down";
let lastScroll = 0;
const body = document.body;
window.onscroll = function () {  
    const currentScroll = window.pageYOffset;


    if (currentScroll <= 0) {
        body.classList.remove(scrollUp);
        return;
    }


    if (!(window.matchMedia('(min-width: 768px)').matches)) {

        if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
            // down
            body.classList.remove(scrollUp);
            body.classList.add(scrollDown);
        } else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
            // up
            body.classList.remove(scrollDown);
            body.classList.add(scrollUp);
        }
    } else {
        if (body.classList.contains(scrollDown) || body.classList.contains(scrollUp)) {
            body.classList.remove(scrollDown);
            body.classList.remove(scrollUp);
        }

    }
    lastScroll = currentScroll;
}